import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2026 from '../CoScholacticSidebar2026/CoScholacticSidebar2026';




const FieldTripClass72026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip7/1.webp`;
const p2 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip7/2.webp`;
const p3 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip7/3.webp`;
const p4 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip7/4.webp`;
const p5 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip7/5.webp`;
const p6 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip7/6.webp`;

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}



  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      FIELD TRIP CLASS 7
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Class: 7	 Date: 23 August 2025  

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
Place of Visit: Ranganathittu Bird Sanctuary, Tipu Sultan’s Summer Palace, Talakadu
<br/>
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
A Journey Through History, Heritage and Nature
<br></br>
The students of Class 7 embarked on an enriching field trip that took students beyond the classroom to explore history, heritage, architecture and nature firsthand, 
connecting textbook learning with real experiences.  
     <br></br>
Their first stop was Tipu Sultan’s Palace, where they explored the striking mural paintings depicting significant historical events and learnt about Tipu Sultan’s resistance to British rule. They also gained insights into Daria Daulat Bagh,
 his summer palace at Srirangapatna, and its distinctive architecture and artistic details.       
  <br></br>
At Ranganathittu Bird Sanctuary, students observed diverse bird species and learned how wetlands, water bodies and trees sustain biodiversity.
        <br></br>
        Their exploration continued at Talakadu, where they discovered its fascinating sand dunes, ancient temples and connection with the River Kaveri. At the Keerthinarayana Temple and Vaidyanatheshwara Temple, the intricate carvings 
        and architectural features offered a glimpse into Karnataka’s rich cultural heritage.
        <br></br>
        The field trip brought together History, Geography, Environmental Studies and Art, making learning engaging, experiential and memorable. It encouraged students to observe, explore and appreciate the importance of preserving both 
        our natural and cultural heritage—proving that learning truly comes alive outside the classroom.
         <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “History explored, heritage cherished, nature discovered."

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 350 : 550}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default FieldTripClass72026;